export default __webpack_public_path__ + "static/media/licenseplan.ac18c728.svg";